<template>
  <BaseTableRow
    v-for="customRole in roles"
    :key="customRole.id"
    :item="customRole"
  >
    <template #default>
      <BaseTableCell>
        <div class="flex items-center gap-2">
          <span class="font-bold text-xs text-slate-900 dark:text-slate-100">
            {{ customRole.name }}
          </span>
          <span
            v-if="customRole.team_scoped_access"
            class="px-2 py-0.2 rounded-full text-[10px] font-bold bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300"
            title="Acesso isolado aos times vinculados"
          >
            👥 Time Restrito
          </span>
        </div>
      </BaseTableCell>

      <BaseTableCell>
        <div class="flex flex-col gap-0.5">
          <span class="text-xs text-slate-600 dark:text-slate-400 line-clamp-1">
            {{ customRole.description || 'Sem descrição cadastrada' }}
          </span>
          <span v-if="customRole.hidden_menu_items && customRole.hidden_menu_items.length" class="text-[10px] text-rose-500 font-semibold">
            🚫 {{ customRole.hidden_menu_items.length }} abas de menu ocultadas
          </span>
        </div>
      </BaseTableCell>

      <BaseTableCell>
        <div class="flex items-center gap-1.5 flex-wrap">
          <span class="px-2 py-0.5 rounded-md text-[11px] font-bold bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300">
            🛡️ {{ customRole.permissions?.length || 0 }} permissões ativas
          </span>
        </div>
      </BaseTableCell>

      <BaseTableCell align="end" class="w-24">
        <div class="flex gap-2 justify-end flex-shrink-0">
          <Button
            v-tooltip.top="$t('CUSTOM_ROLE.EDIT.BUTTON_TEXT')"
            icon="i-woot-edit-pen"
            slate
            sm
            @click="emit('edit', customRole)"
          />
          <Button
            v-tooltip.top="$t('CUSTOM_ROLE.DELETE.BUTTON_TEXT')"
            icon="i-woot-bin"
            slate
            sm
            class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
            :is-loading="loading[customRole.id]"
            @click="emit('delete', customRole)"
          />
        </div>
      </BaseTableCell>
    </template>
  </BaseTableRow>
</template>

<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { BaseTableRow, BaseTableCell } from 'dashboard/components-next/table';

defineProps({
  roles: {
    type: Array,
    required: true,
  },
  loading: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['edit', 'delete']);
</script>
